import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { CustomerService } from 'src/app/services/customer/customer.service';
import * as _ from 'lodash';
import { AddSupplierUserComponent } from '../add-supplier-user.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';


@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmSupplierComponent implements OnInit {
  @ViewChild(RouterOutlet, { static: false }) outlet: RouterOutlet;
  @Output() close = new EventEmitter();
  private activatedRoute: ActivatedRoute;
  public loading: boolean = false;
  private sub: any;
  public supplierUserID: string;
  public supplier;
  private redirectUrl: string;
  public isSaved = false;


  constructor(public supplierService: SupplierService,
    private flashMessageService: FlashMessageService,
    private customerService: CustomerService,
    private _gaSvc: GoogleAnalyticsService,
    public currentUserService: CurrentUserService,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute, private router: Router,
    activatedRoute: ActivatedRoute,
    private modal: ModalService) {
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe(params => {
      this.supplierUserID = params['ID'];
      this.redirectUrl = params['urlPath'] ? params['urlPath'].split(`'`)[1] : null;
    });
    this.getSupplier();
  }

  getSupplier() {
    this.supplierService.getSupplierDetail(this.supplierService.newSupplierUser.organization_id).then(supplier => {
      this.supplier = supplier;
      this.ref.detectChanges();
    });
  }

  confirm() {
    this.loading = true;
    this.supplierService.createSupplierUser()
      .then(async (res) => {
        let roleCode = _.get(res, 'applications[0].roleCode', '');
        if (this.supplierService.newSupplierUser.user_from_request) {
          await this.customerService.removeCustomerRequest(this.supplierService.newSupplierUser.requestId, this.supplierService.newSupplierUser.requestType);
        }

        let customerId = this.customerService.newCustomerUser.organization_id;
        this._gaSvc.register('Create Supplier User', 'Create Customer User for User Role: ' + roleCode, 'Create Customer User for Customer: ' + this.supplier.name);

        this.loading = false;
        this.isSaved = true;
        this.flashMessageService.updateMessage("Successfully created user", 3000, "success");
        this.supplierService.resetSupplierUser();
        this.modal.close();
      }).catch((err) => {
        this.loading = false;
        if (err.status === 409) {
          this.flashMessageService.updateMessage(err['error']['error'], 3000);
        } else {
          this.flashMessageService.updateMessage('Failed to Add New User.', 3000);
        }
      });
  }
  //Go to Create Component.
  //Passing the pre entered values with the query param
  onEditDetails() {
    this.router.navigate([
      { outlets: { sup: 'create' } }
    ], {
      queryParams: {
        edit: true, supplierID: this.supplierService.newSupplierUser.organization_id,
        name: this.supplierService.newSupplierUser.name,
        email: this.supplierService.newSupplierUser.email,
        phone: this.supplierService.newSupplierUser.phone,
        mobile: this.supplierService.newSupplierUser.mobile_phone,
        userType: this.supplierService.newSupplierUser.roleCode,
        entitlements: this.supplierService.newSupplierUser.entitlements
      }
    });
  }
}
